import { render, staticRenderFns } from "./SingleWidget.vue?vue&type=template&id=71d52a6a&"
import script from "./SingleWidget.vue?vue&type=script&lang=js&"
export * from "./SingleWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports